import { baseApi } from '../baseApi';
import { gql } from 'graphql-request';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // queries
    retrievePrimaryCredentials: builder.query({
      query: (secondaryEmailOrMobile: String) => ({
        body: gql`
          query RetrieveCredentials($secondaryEmailOrMobile: String) {
            retrievePrimaryCredentials(secondaryEmailOrMobile: $secondaryEmailOrMobile) {
              id
            }
          }
        `,
        variables: {
          secondaryEmailOrMobile,
        },
      }),
      transformResponse: (res: any): any => res.retrievePrimaryCredentials,
    }),

    // mutations
    login: builder.mutation({
      query: ({ userEmailorUsername, password, accountLicence, isForce, deviceSessionToken }: any) => ({
        body: gql`
          mutation Login($userEmailorUsername: String, $password: String, $subsite: String, $accountLicence: String, $isForce: Boolean, $deviceSessionToken: String) {
            login(
              userEmailorUsername: $userEmailorUsername
              password: $password
              subsite: $subsite
              accountLicence: $accountLicence
              isForce: $isForce
              deviceSessionToken: $deviceSessionToken
            ) {
              id
              access_token
              refresh_token
              expires_at
              browser
              platform
              user_account {
                device_session_token
              }
            }
          }
        `,
        variables: {
          userEmailorUsername,
          password,
          subsite: 'MAIN',
          accountLicence,
          isForce,
          deviceSessionToken
        },
      }),
      transformResponse: (res: any): any => res.login,
    }),
    logout: builder.mutation({
      query: () => ({
        body: gql`
          mutation Logout {
            logout {
              success
            }
          }
        `,
      }),
      transformResponse: (res: any): any => res.logout,
      async onQueryStarted(args: any, { queryFulfilled }: any) {
        try {
          const { data } = await queryFulfilled;
          return data;
        } catch (error) {
          //@ts-ignore
          if (error?.error?.status === 500) window.location.href = '/500';
          return error;
        }
      },
    }),
    requestResetPassword: builder.mutation({
      query: (emailOrMobile: String) => ({
        body: gql`
          mutation RequestResetPassword($emailOrMobile: String) {
            requestResetPassword(emailOrMobile: $emailOrMobile) {
              id
            }
          }
        `,
        variables: {
          emailOrMobile,
        },
      }),
      transformResponse: (res: any): any => res.requestResetPassword,
    }),
    resetPassword: builder.mutation({
      query: ({ newPassword, token }: any) => ({
        body: gql`
          mutation ResetPassword($newPassword: String, $token: String) {
            resetPassword(newPassword: $newPassword, token: $token) {
              newPassword
              token {
                access_token
                refresh_token
              }
            }
          }
        `,
        variables: {
          newPassword,
          token,
        },
      }),
      transformResponse: (res: any): any => res.resetPassword,
    }),
    unlockAccount: builder.mutation({
      query: ({ email, token, exp, sig }: any) => ({
        body: gql`
          mutation UnlockAccount($email: String, $token: String, $exp: String, $sig: String) {
            unlockAccount(email: $email, token: $token, exp: $exp, sig: $sig) {
              email
            }
          }
        `,
        variables: {
          email, token, exp, sig
        },
      }),
      transformResponse: (res: any): any => res.unlockAccount,
    }),
    contactAdmin: builder.mutation({
      query: ({ email, affiliation, comments }: any) => ({
        body: gql`
          mutation ContactAdmin($email: String, $affiliation: String, $comments: String) {
            contactAdmin(email: $email, affiliation: $affiliation, comments: $comments) {
              status
              data {
                email
                affiliation
                comments
              }
            }
          }
        `,
        variables: {
          email: email,
          affiliation: affiliation,
          comments: comments,
        },
      }),
      transformResponse: (res: any): any => res.contactAdmin,
    }),
  }),
  overrideExisting: false,
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useLazyRetrievePrimaryCredentialsQuery,
  useRequestResetPasswordMutation,
  useResetPasswordMutation,
  useUnlockAccountMutation,
  useContactAdminMutation,
} = authApi;
